import httpApi from '../httpApi';

class OrganisationService {
	createOrganisation(data) {
		return httpApi.put('/organisation', data);
	}
	
	getBySubdomain() {
		return httpApi.get('/organisation/subdomain');
	}
	
	updateBySubdomain(data) {
		return httpApi.post('/organisation', data);
	}
	
	updateThemeBySubdomain(data) {
		return httpApi.post('/theme', data);
	}
	
	createGroup(data) {
		return httpApi.put('/group', data);
	}
	
	updateGroup(data) {
		return httpApi.post('/group', data);
	}
	
	updateGroupAssignment(data) {
		return httpApi.patch('/group', data);
	}	
}

export default new OrganisationService();
